/* ----------------------------------------- */
// File which holds custom jQuery functions
window.jQuery(document).ready(function($){
});



// WEBPACK FOOTER //
// ./src/assets/js/main.js